module.exports = __webpack_public_path__ + "img/fishing-site-thumb-1.cb5c8a75.jpg";